import ScriptsLoader from "@/module/Utils/ScriptsLoader";
import Vue from "vue";

export class SentryLoader {
  public static loadSentry(): void {
    const hostname = String(window.location.hostname);

    if (
      // @ts-ignore
      window.Sentry !== undefined ||
      hostname.includes(".loc") ||
      hostname.includes(".docker") ||
      hostname.includes(".circle")
    ) {
      return;
    }

    ScriptsLoader.loadScript(
      "https://browser.sentry-cdn.com/7.34.0/bundle.min.js",
      () => {
        ScriptsLoader.loadScript(
          "https://browser.sentry-cdn.com/6.19.7/vue.min.js",
          () => {
            if (
              // @ts-ignore
              window.Sentry === undefined ||
              // @ts-ignore
              !window.Sentry.init ||
              // @ts-ignore
              {}.toString.call(window.Sentry.init) !== "[object Function]" ||
              // @ts-ignore
              window.Sentry.Integrations === undefined ||
              // @ts-ignore
              {}.toString.call(window.Sentry.Integrations.Vue) !==
                "[object Function]"
            ) {
              return;
            }

            // @ts-ignore
            window.Sentry.init({
              dsn: "https://365be1ca0e36db4d5560f926dd1ca974@sentry.fapi.cloud/3",
              tracesSampleRate: 1.0,
              integrations: [
                // @ts-ignore
                new window.Sentry.Integrations.Vue({
                  Vue,
                  attachProps: true,
                  logErrors: true,
                }),
              ],
              beforeSend: (event: any): any => {
                // if (
                //   !event ||
                //   !event.hasOwnProperty("contexts") ||
                //   !event.contexts
                // ) {
                //   return null;
                // }
                //
                // if (!event.contexts.hasOwnProperty("vue")) {
                //   return null;
                // }

                return event;
              },
            });
          },
        );
      },
    );
  }
}
